<template>
  <div id="app" :style="{fontSize: fontSize + 'px', width: overWidth + 'px'}"> 
    <div class="content">
      <h4>联系我们</h4>
      <ol>
        <li>1、邮箱：support@lbota.net</li>
        <li>2、手机号：+8615150621579</li>
        <li>3、QQ技术交流群：</li>
        <li>绿叶助手官方群：597848001</li>
        <li>4、地址：江苏省南京市江北新区浦泗路18号</li>
        <li>
          <img src="./assets/address.png">
        </li>
      </ol>
    </div>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  },
  data () {
    return {
      overWidth: document.documentElement.clientWidth,
      overHeight: document.documentElement.clientHeight,
      fontSize: 14
    }
  },
  watch: {
    overWidth (val) {
      this.overWidth = val
      this.setSize()
    }
  },
  methods: {
    getFontSize () {
      return this.overWidth / 320 * 12
    },
    setSize () {
      if (this.overWidth / this.overHeight > 0.7) { this.overWidth = this.overHeight * 0.7} 
      this.fontSize = this.getFontSize()
    }
  },
  mounted () {
    window.onresize = () => {
      this.overWidth = document.documentElement.clientWidth
      this.overHeight = document.documentElement.clientHeight
    }
  },
  created () {
    this.setSize()
  }
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  background: no-repeat 0 0;
  background-size: 100% auto;
  font-size: inherit;
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
  line-height: inherit;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
body {
  width: 100%;
  height: auto;
  -webkit-user-select: none;
  user-select: none;
  color: #333;
}
li {
  list-style: none;
  margin: 1em 0;
}
li:nth-child(4) {
  margin-left: 2em;
}
button, input {
  outline: none;
  border: none;
}
a {
  text-decoration: none;
  color: inherit;
}
h4 {
  font-size: 1.2em;
  margin-bottom: 1em;
  font-weight: 700;
}
#app {
  font-family: -apple-system-font,
  BlinkMacSystemFont,
  "Helvetica Neue",
  "PingFang SC",
  "Hiragino Sans GB",
  "Microsoft YaHei UI",
  "Microsoft YaHei",
  Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0 auto;
}
.head img {
  width: 100%;
}
.content {
  padding: 4%;
}
.qq-group {
  padding-left: 1em;
}
.content img {
  width: 100%;
}
</style>
